import React from 'react';
import classes from 'classnames';
import PropTypes from 'prop-types';

export const Button = React.forwardRef((rawProps, ref) => {
	const props = { disabled: false, ...rawProps };
	return (
		<button ref={ref}
				id={props.id || ''}
				className={classes(props.className, 'k-button', {'k-primary': props.primary})}
		        onClick={(e) => props.onClick(e)}
		        title={props.hoverText}
		        style={props.style}
		        disabled={props.disabled}>
			{props.title}
		</button>
	);
});

export default Button;

Button.propTypes = {
	title: PropTypes.any,
	primary: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	style: PropTypes.object
};
